import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  useControl,
  useFreeTextFormContext,
} from '../../components/ControlLayout/ControlLayout';
import { useGetReportTextTemplate } from '../../../../traits/api/reportTextTemplates/useGetReportTextTemplate';
import {
  formatControlDateTime,
  interpolateAssignmentDescription,
} from '../../utils/reportTextTemplates';

import { S } from './FreeTextSummary.styles';

export const FreeTextSummary: React.FC = () => {
  const navigate = useNavigate();
  const { data } = useControl();
  const { state } = useParams();
  const { register, trigger, setValue } = useFreeTextFormContext();
  const assignmentTemplate = useGetReportTextTemplate('assignmentDescription');

  const navigateToSummary = async () => {
    const isValid = await trigger();
    if (!isValid) return;
    navigate(`/kontroller/${state}/${data.inspectionId}/bedomning`);
  };

  const navigateToFlyleaf = async () => {
    navigate(`/kontroller/${state}/${data.inspectionId}/forsattsblad`);
  };

  const generateAssignmentDescription = () => {
    if (!assignmentTemplate.data?.body) return;

    setValue(
      'assignmentDescription',
      interpolateAssignmentDescription(assignmentTemplate.data.body, {
        date: formatControlDateTime(data.date),
        completedAt: data.completedAt
          ? formatControlDateTime(data.completedAt)
          : 'AVSLUTNINGSTID SAKNAS',
        projectName: data.project.name.trim(),
        address: data.address.trim(),
        city: data.city.name.trim(),
        clientName: data.client.name,
        mainContractor: data.mainContractor.trim(),
      })
    );
  };

  return (
    <S.FreeTextSummaryContainer>
      <S.FreeTextSummaryInner type="single" defaultValue="1" paddingbottom={24}>
        <S.H4>Uppdragsbeskrivning</S.H4>

        <S.Body value="1">
          <S.Header>
            <S.Icon src="Edit" />
            <S.H6>Beskrivning</S.H6>
          </S.Header>

          <S.BodyInner>
            <S.Textarea
              placeholder="Skriv här..."
              {...register('assignmentDescription')}
            />
            <S.Button
              onClick={generateAssignmentDescription}
              disabled={!assignmentTemplate.data?.body}
            >
              Generera Text
            </S.Button>
          </S.BodyInner>
        </S.Body>

        <S.Footer>
          <S.Button $outlined onClick={navigateToFlyleaf}>
            Föregående
          </S.Button>

          <S.Button onClick={navigateToSummary}>Nästa</S.Button>
        </S.Footer>
      </S.FreeTextSummaryInner>
    </S.FreeTextSummaryContainer>
  );
};
